module.exports = __webpack_public_path__ + "static/media/game(2).56dd4832.PNG";